export default __webpack_public_path__ + "static/media/mg-icon-active.47300070.svg";